jQuery(function($){

    if ($('.werkwijze').length == 0){
        return;
    }

    // For speed reasons, scroll event only fires when the section is actually in view
    let intersectTrigger = document.querySelector('.werkwijze');

    function handleIntersect(entries, observer) {
        entries.forEach(entry => {       
            if (entry.isIntersecting) {  
                const listElement = document.querySelector('.werkwijze__list');
                const circle = document.querySelector('.circle-progress');

                let items = $('.werkwijze__item');
                let countItems = $('.werkwijze__animation-number.active-number');
                let numberItems = $('.werkwijze__count');

                $(window).on('scroll.werkwijze', function() {       
                    const listRect = listElement.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                
                    // Calculate the adjusted top position and height
                    // Middle of the screen
                    const adjustedTop = listRect.top + windowHeight / 2;
                    const adjustedHeight = listRect.height;

                    // Calculate the scroll percentage
                    let scrollPercent = (windowHeight - adjustedTop) / (adjustedHeight);
                    scrollPercent = Math.max(0, Math.min(1, scrollPercent)); 

                    if (scrollPercent < 0.25){
                        items.removeClass('active');
                        items.eq(0).addClass('active');
                        numberItems.removeClass('active');
                        numberItems.eq(0).addClass('active');

                        numberItems.addClass('done');
                        numberItems.eq(0).removeClass('done');
                        numberItems.eq(1).removeClass('done');
                        numberItems.eq(2).removeClass('done');
                        numberItems.eq(3).removeClass('done');
                    }
                    else if (scrollPercent > 0.25 && scrollPercent < 0.5){
                        items.removeClass('active');
                        items.eq(1).addClass('active');
                        numberItems.removeClass('active');
                        numberItems.eq(1).addClass('active');

                        numberItems.addClass('done');
                        numberItems.eq(1).removeClass('done');
                        numberItems.eq(2).removeClass('done');
                        numberItems.eq(3).removeClass('done');
                    }
                    else if (scrollPercent > 0.5 && scrollPercent < 0.75){
                        items.removeClass('active');
                        items.eq(2).addClass('active');
                        numberItems.removeClass('active');
                        numberItems.eq(2).addClass('active');
         
                        numberItems.addClass('done');
                        numberItems.eq(2).removeClass('done');
                        numberItems.eq(3).removeClass('done');
                    }
                    else {
                        items.removeClass('active');
                        items.eq(3).addClass('active');
                        numberItems.removeClass('active');
                        numberItems.eq(3).addClass('active');

                        numberItems.addClass('done');
                        numberItems.eq(3).removeClass('done');
                    }

                    if (scrollPercent > 0.24){
                        countItems.removeClass('active');
                        countItems.eq(0).addClass('active');
                        countItems.eq(1).addClass('active');
                    }
                    if (scrollPercent > 0.49){
                        countItems.removeClass('active');
                        countItems.eq(0).addClass('active');
                        countItems.eq(1).addClass('active');
                        countItems.eq(2).addClass('active');
                    }
                    if (scrollPercent > 0.74){
                        countItems.removeClass('active');
                        countItems.eq(0).addClass('active');
                        countItems.eq(1).addClass('active');
                        countItems.eq(2).addClass('active');
                        countItems.eq(3).addClass('active');
                    }
                    if (scrollPercent <= 0.24){
                        countItems.removeClass('active');
                        countItems.eq(0).addClass('active');
                    }
                
                    // Calculate the stroke-dashoffset
                    const radius = circle.r.baseVal.value;
                    const circumference = 2 * Math.PI * radius;
                    const offset = circumference - (scrollPercent * circumference);
                
                    // Update the stroke-dashoffset
                    circle.style.strokeDashoffset = offset;
                });  
            }
            else {
                $(window).off('scroll.werkwijze');

            }
        });
    }

    const observer = new IntersectionObserver(handleIntersect, {
        root: null, 
        threshold: 0 
    });

    observer.observe(intersectTrigger);



    
});